'use strict'

import { serverApi } from '@/server';

export default {

    /**
     * 商户列表
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     * 
     * @url: /merchants
     */
    merchants(formData) {
        const url = '/merchants';
        return serverApi.get(formData, url);
    },
    /**
     * 商户详情-基础信息
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     * 
     * @url: /merchants/5
     */
    getMerchantsInfo(id) {
        const url = `/merchants/${id}`;
        return serverApi.get({}, url);
    },
    /**
     *  商户详情-签约协议文件预览
     * @param {*} id 
     */
    merchantsSignTempPreview(fomrData = {}) {
        const url = `/merchants-sign-temp-preview`
        return serverApi.post(fomrData, url);
    },
    /**
     * 商户详情-签约协议文件下载
     *
     *
     * @method POST
     * 
     * @url: /merchants-sign-temp-download
     */
    merchantsSignTempDownload(formData, fileName) {
        let url = `/merchants-sign-temp-download`;
        return serverApi.get(formData, url, fileName);
    },
    /**
     * 商户管理-- - 签约个体--基础信息
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     * 
     * @url: /api/credit-records
     */
    getSignPeopleInfo(id) {
        const url = `/merchants/${id}`;
        return serverApi.get({}, url);
    },
    /**
     * 商户管理-- - 签约个体列表
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     * 
     * @url: /api/credit-records
     */
    SignMerchants(formData) {
        const url = `/system-individuals`;
        return serverApi.get(formData, url);
    },
    /**
     * 商户管理-- - 打款明细--基础信息
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     * 
     * @url: /api/credit-records
     */
    getPayDetailsInfo(id) {
        const url = `/merchants/${id}`;
        return serverApi.get({}, url);
    },
    /**
     * 商户管理-- - 打款明细列表
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     * 
     * @url: /api/credit-records
     */
    PayDetailsList(formData, id) {
        const url = `system-pay-details/${id}`;
        return serverApi.get(formData, url);
    },
    /**
     * 商户管理-- - 签约信息
     *
     *
     * @method GET
     * 
     * @url: /merchant-sign-info
     */
    merchantSignInfo(id) {
        const url = `/merchant-sign-info/${id}`;
        return serverApi.get({}, url);
    },
    /**
     *  商户详情-风控资料预览
     * @param {*} id 
     */
    merchantsRiskPreview(fomrData = {}) {
        const url = `/merchants-risk-preview`
        return serverApi.post(fomrData, url);
    },
    /**
     * 商户执照预览
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method POST
     * 
     * @url: /spa/preview-license-file
     */
    previewLicenseFile(formData) {
        let url = `/preview-license-file`;
        return serverApi.post(formData, url);
    },

    /**
     * 个体信息--身份证号脱敏查看
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick 
     * 
     * @method GET
     * 
     * @url: /spa/individual-show-idcard/{id}
     */
    individualShowIdcard(id) {
        const url = `/individual-show-idcard/${id}`
        return serverApi.get({}, url);
    },
    /**
     * 个体信息--手机号脱敏查看
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick 
     * 
     * @method GET
     * 
     * @url: /spa/individual-show-phone/{id}
     */
    individualShowPhone(id) {
        const url = `/individual-show-phone/${id}`
        return serverApi.get({}, url);
    },
    /**
     * 获取商户名
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     * 
     * @url: /select-merchants
     */
    getMerchantsLis(formData) {
        const url = `/select-merchants`;
        return serverApi.get(formData, url);
    },
}